import React, { Children, cloneElement, useEffect } from 'react';
import lodash from 'lodash';
import { getStudyRoles } from 'pages/studyOverview/actions/studySettings';
import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';
import { connect } from 'react-redux';
import { Tabs } from 'components/common/Tabs/Tabs';
import { PageTitle, PageDescription } from 'components/common/Study/PageComponents';
import { loadStudyExpectations, removeStudyExpectations } from 'pages/studyOverview/actions/studyExpectations';
import styles from './StudySettingsExpectations.scss';
import { loadHomePageV4Access } from '../../../../../common/features/predicates';


export function StudySettingsExpectations(props) {
    const childElement = cloneElement(Children.only(props.children), props);
    const { study, location } = props;

    useEffect(() => {
        props.getStudyRoles(study.institutionId);
        props.loadStudyExpectations();
    }, []);


    const buildTabs = (studyId) => {
        const mainPath = `/study/${studyId}/settings/expectations`;

        return [{
            label: 'Study Documents',
            path: `${mainPath}/study-documents`,
            backgroundHighlight: true,
        }, {
            label: 'Staff Documents',
            path: `${mainPath}/staff-documents`,
            backgroundHighlight: true,
        }];
    };

    if (props.isProcessing) {
        return (
            <LoadingStatus actionLabel={'processing'} itemName={'study settings expectation'} loading={true} filterQuery={false} />
        );
    }

    return (
        <div data-cy="StudySettingsExpectations">
            <PageTitle>Expectations Settings</PageTitle>
            <PageDescription className={styles.pageDescription}>
                Modify the checklist of documents needed for the lifecycle stage this {props.complion4FlagEnabled ? 'binder' : 'study'} is in.
            </PageDescription>
            <Tabs
                className={styles.tabs}
                tabs={buildTabs(study.id)}
                location={location}
            />
            <div data-cy="StudySettingsExpectations-childElement">
                {childElement}
            </div>
        </div>
    );
}

export default connect((state) => {
    const studyExpectations = lodash.get(state, 'study.studyExpectations', []);
    const studyRoles = lodash.get(state, 'study.studyRoles', []);
    const staffDocuments = lodash.filter(studyExpectations, (studyExpectation) => !lodash.isNil(studyExpectation.studyRoleId));
    const studyDocuments = lodash.filter(studyExpectations, (studyExpectation) => lodash.isNil(studyExpectation.studyRoleId));
    const staffDocumentExpectations = lodash.get(state, 'study.staffDocumentExpectations', []);
    const studyDocumentExpectations = lodash.get(state, 'study.studyDocumentExpectations', []);
    const isProcessing = lodash.get(state, 'processingStudyExpectations', false);
    const sortedStaffDocumentExpectations = lodash.sortBy(staffDocumentExpectations, ['sourceId']);
    const staffExpectationsGroupByName = !lodash.isEmpty(sortedStaffDocumentExpectations) ?
        lodash.groupBy(sortedStaffDocumentExpectations, expectation => expectation.name) :
        null;

    return {
        studyRoles,
        isProcessing,
        staffDocuments,
        studyDocuments,
        studyExpectations,
        staffDocumentExpectations,
        studyDocumentExpectations,
        staffExpectationsGroupByName,
        complion4FlagEnabled: loadHomePageV4Access(state),
    };
}, {
    getStudyRoles,
    loadStudyExpectations,
    removeStudyExpectations,
})(StudySettingsExpectations);